import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  current_page: 1,
  page_size: 10,
  has_more: false,
  total_page: 0,
  total_count: 0,
  data: [],
  filters: {},
  editData: [],
};

export const HelpFormSlice = createSlice({
  name: "HelpFormReducer",
  initialState,
  reducers: {
    setHelpData: (state, action) => {
      state.editData = action.payload;
    },

    resetState: (state) => {
      state.editData = {};
    },
  },
});

export const { setHelpData, resetState } = HelpFormSlice.actions;

export default HelpFormSlice.reducer;
